(function () {
  "use strict";

  var STORAGE_KEY = "ta_mc_quote_data_v1";
  var QUOTE_REFERENCE_STORAGE_KEY = "ta_quote_ref";
  
  // Change only this URL when promoting v3 from dev to production.
  var API_URL = "https://api.teleadapt.com/api/v1/subscribers";
  
  var TURNSTILE_SITE_KEY = "0x4AAAAAAEDHIc-JmyqtxRyG";
  var TURNSTILE_CONTAINER_ID = "ta-turnstile-v3";
  var STATUS_ELEMENT_ID = "ta-subscribe-status-v3";
  var LOG_PREFIX = "[TA Quote v3]";
  var TURNSTILE_SCRIPT_URL =
    "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
  var REDIRECT_TIMEOUT_MS = 15000;
  var turnstileLoadPromise;
  var subscriptionStarted = false;
  var apiRequestStarted = false;
  var redirectStarted = false;
  var redirectTimeoutId = null;

  function log(method) {
    var args = Array.prototype.slice.call(arguments, 1);
    args.unshift(
      LOG_PREFIX,
      new Date().toISOString()
    );
    console[method].apply(console, args);
  }

  function readStoredData() {
    var value;

    try {
      value = sessionStorage.getItem(STORAGE_KEY);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      log("warn", "Could not read stored quote data.", error.message);
      return null;
    }
  }

  function writeStoredData(data) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      return true;
    } catch (error) {
      log("warn", "Could not store quote data.", error.message);
      return false;
    }
  }

  function setStatus(message) {
    var status = document.getElementById(STATUS_ELEMENT_ID);

    if (status) {
      status.textContent = message;
    }
  }

  function failureStatus() {
    setStatus(
      "Your quote was submitted, but newsletter signup could not be completed."
    );
  }

  function redirectToThankYou(reason) {
    if (redirectStarted) {
      return;
    }
    redirectStarted = true;

    if (redirectTimeoutId !== null) {
      window.clearTimeout(redirectTimeoutId);
      redirectTimeoutId = null;
    }

    window.location.assign("/pages/request-quote-thank-you-with-ref");
  }

  function q(selector, root) {
    return (root || document).querySelector(selector);
  }

  function byPlaceholder(needles, root) {
    root = root || document;
    needles = Array.isArray(needles) ? needles : [needles];
    var selector = needles
      .map(function (text) {
        return (
          'input[placeholder*="' +
          text +
          '" i], textarea[placeholder*="' +
          text +
          '" i]'
        );
      })
      .join(",");
    return q(selector, root);
  }

  function byLabel(needle, root) {
    root = root || document;
    needle = (needle || "").toLowerCase();
    var labels = root.querySelectorAll("label");
    var i;
    var text;
    var forId;
    var element;
    var next;

    for (i = 0; i < labels.length; i += 1) {
      text = (labels[i].textContent || "").trim().toLowerCase();
      if (!needle || text.includes(needle)) {
        forId = labels[i].getAttribute("for");
        if (forId) {
          element = root.querySelector("#" + CSS.escape(forId));
          if (element) {
            return element;
          }
        }
        next = labels[i].nextElementSibling;
        while (
          next &&
          next.tagName &&
          !/^(INPUT|TEXTAREA|SELECT)$/i.test(next.tagName)
        ) {
          next = next.nextElementSibling;
        }
        if (next) {
          return next;
        }
      }
    }
    return null;
  }

  function findConsent(root) {
    root = root || document;
    var box = root.querySelector(
      'input[name="subscribe_newsletter"][value="1"]'
    );
    var boxes;
    var i;
    var label;
    var text;

    if (box) {
      return box;
    }

    box = root.querySelector('input[name="subscribe_newsletter"]');
    if (box) {
      return box;
    }

    boxes = root.querySelectorAll('input[type="checkbox"]');
    for (i = 0; i < boxes.length; i += 1) {
      label = boxes[i].closest("label") || boxes[i].parentElement;
      text =
        label && label.textContent
          ? label.textContent.trim().toLowerCase()
          : "";
      if (text.startsWith("yes, i’d like to receive")) {
        return boxes[i];
      }
    }
    return null;
  }

  function ensure(value, fallback) {
    value = (value || "").trim();
    return value ? value : fallback;
  }

  function roomCountForBand(band) {
    var roomCounts = {
      "1-50": 50,
      "51-100": 100,
      "101-250": 250,
      "251-500": 500,
      "501-1000": 1000,
      "1001-5000": 5000,
      "5001+": 5001
    };

    return roomCounts[band];
  }

  function discoverFields(form) {
    return {
      email:
        q('input[type="email"]', form) ||
        byPlaceholder(["email", "mail"], form) ||
        byLabel("email", form),
      fname:
        byPlaceholder(["first name", "given", "first"], form) ||
        byLabel("first name", form),
      lname:
        byPlaceholder(["last name", "surname", "last"], form) ||
        byLabel("last name", form),
      fullName:
        byPlaceholder(["full name", "your name"], form) ||
        byLabel("full name", form),
      company: byPlaceholder("company", form) || byLabel("company", form),
      title: byPlaceholder("title", form) || byLabel("title", form),
      phone:
        q('input[type="tel"]', form) ||
        byPlaceholder("phone", form) ||
        byLabel("phone", form),
      roomBand: q('select[name="contact[Number of Rooms]"]', form),
      consent: findConsent(form)
    };
  }

  function fieldValue(field) {
    return field ? field.value.trim() : "";
  }

  function storeCurrentForm(form) {
    var previous = readStoredData() || {};
    var fields = discoverFields(form);
    var fname = fieldValue(fields.fname);
    var lname = fieldValue(fields.lname);
    var fullName = fieldValue(fields.fullName);
    var parts;

    if ((!fname || !lname) && fullName) {
      parts = fullName.split(/\s+/);
      if (!fname) {
        fname = parts[0] || "";
      }
      if (!lname) {
        lname = parts.slice(1).join(" ");
      }
    }

    var data = {
      email: ensure(fieldValue(fields.email), previous.email || ""),
      fname: ensure(fname, previous.fname || "-"),
      lname: ensure(lname, previous.lname || "-"),
      company: ensure(
        fieldValue(fields.company),
        previous.company || ""
      ),
      title: ensure(fieldValue(fields.title), previous.title || ""),
      phone: ensure(fieldValue(fields.phone), previous.phone || ""),
      roomBand: ensure(
        fieldValue(fields.roomBand),
        previous.roomBand || ""
      ),
      consentCheckboxFound: Boolean(fields.consent),
      consent: fields.consent ? fields.consent.checked === true : true,
      sentQuoteReference: ensure(previous.sentQuoteReference, "")
    };

    writeStoredData(data);
  }

  function initialiseFormPersistence() {
    var form = document.querySelector("#contact_form");

    if (!form) {
      log("warn", "Required quote form was not found.");
      return;
    }

    form.addEventListener("input", function () {
      storeCurrentForm(form);
    });
    form.addEventListener("change", function () {
      storeCurrentForm(form);
    });
  }

  function loadTurnstile() {
    var existingScript;

    if (window.turnstile) {
      return Promise.resolve(window.turnstile);
    }

    if (turnstileLoadPromise) {
      return turnstileLoadPromise;
    }

    turnstileLoadPromise = new Promise(function (resolve, reject) {
      function loaded() {
        if (window.turnstile) {
          resolve(window.turnstile);
        } else {
          reject(new Error("Turnstile loaded without exposing its API."));
        }
      }

      existingScript = document.querySelector(
        'script[src="' + TURNSTILE_SCRIPT_URL + '"]'
      );

      if (existingScript) {
        existingScript.addEventListener("load", loaded, { once: true });
        existingScript.addEventListener(
          "error",
          function () {
            reject(new Error("Turnstile script failed to load."));
          },
          { once: true }
        );
        return;
      }

      existingScript = document.createElement("script");
      existingScript.src = TURNSTILE_SCRIPT_URL;
      existingScript.async = true;
      existingScript.defer = true;
      existingScript.addEventListener("load", loaded, { once: true });
      existingScript.addEventListener(
        "error",
        function () {
          reject(new Error("Turnstile script failed to load."));
        },
        { once: true }
      );
      document.head.appendChild(existingScript);
    });

    return turnstileLoadPromise;
  }

  function readQuoteReference() {
    var quoteReference = "";

    try {
      quoteReference =
        sessionStorage.getItem(QUOTE_REFERENCE_STORAGE_KEY) || "";
    } catch (error) {
      log("warn", "Could not read stored quote reference.", error.message);
    }

    return quoteReference.trim();
  }

  function submitSubscription(token, stored, quoteReference) {
    var payload = {
      email: stored.email,
      first_name: stored.fname || "-",
      last_name: stored.lname || "-",
      company: stored.company || "",
      title: stored.title || "",
      phone: stored.phone || "",
      turnstile_token: token,
      marketing_consent:
        stored.consentCheckboxFound === false
          ? true
          : stored.consent !== false
    };
    var roomCount = roomCountForBand(stored.roomBand);

    if (quoteReference) {
      payload.quote_reference = quoteReference;
    }

    if (roomCount !== undefined) {
      payload.room_count = roomCount;
    }

    return fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response
          .json()
          .then(function (result) {
            return { response: response, result: result };
          })
          .catch(function (error) {
            throw {
              type: "invalid-json",
              response: response,
              error: error
            };
          });
      })
      .then(function (outcome) {
        if (!outcome.response.ok || outcome.result.success !== true) {
          throw {
            type: "api-failure",
            status: outcome.response.status,
            success: outcome.result && outcome.result.success,
            result: outcome.result && outcome.result.result
          };
        }

        if (quoteReference) {
          stored.sentQuoteReference = quoteReference;
        }
        writeStoredData(stored);
        setStatus("Newsletter signup completed.");
        redirectToThankYou("apiSuccess");
      })
      .catch(function (error) {
        failureStatus();
        log(
          "error",
          "FETCH FAILED",
          "message=" + (error && error.message ? error.message : error.type || "unknown")
        );
        redirectToThankYou(
          error && (error.type === "api-failure" || error.type === "invalid-json")
            ? "apiFailure"
            : "fetchFailure"
        );
      });
  }

  function initialiseSuccessSubscription() {
    var stored;
    var container;
    var quoteReference;
    var contactPosted = new URLSearchParams(window.location.search).get(
      "contact_posted"
    );

    if (contactPosted !== "true") {
      return;
    }

    if (redirectStarted) {
      return;
    }
    if (redirectTimeoutId === null) {
      redirectTimeoutId = window.setTimeout(function () {
        log("warn", "Turnstile safety fallback triggered.");
        redirectToThankYou("safetyTimeout");
      }, REDIRECT_TIMEOUT_MS);
    }

    stored = readStoredData();
    if (!stored) {
      log("warn", "Required stored quote data was not found.");
      redirectToThankYou("missingStoredData");
      return;
    }
    if (!stored.email) {
      log("warn", "Required stored quote data is incomplete.");
      redirectToThankYou("missingEmail");
      return;
    }

    quoteReference = readQuoteReference();
    if (
      quoteReference &&
      stored.sentQuoteReference === quoteReference
    ) {
      redirectToThankYou("duplicateQuoteReference");
      return;
    }

    if (subscriptionStarted) {
      return;
    }
    subscriptionStarted = true;

    container = document.getElementById(TURNSTILE_CONTAINER_ID);
    if (!container) {
      failureStatus();
      log(
        "warn",
        "Turnstile container #" + TURNSTILE_CONTAINER_ID + " was not found."
      );
      redirectToThankYou("missingTurnstileContainer");
      return;
    }

    loadTurnstile()
      .then(function (turnstile) {
        turnstile.render(container, {
          sitekey: TURNSTILE_SITE_KEY,
          theme: "auto",
          callback: function (token) {
            if (apiRequestStarted) {
              return;
            }
            apiRequestStarted = true;
            submitSubscription(token, stored, quoteReference);
          },
          "error-callback": function (code) {
            failureStatus();
            log(
              "error",
              "Turnstile error callback",
              "codePresent=" + Boolean(code)
            );
            redirectToThankYou("turnstileError");
          },
          "expired-callback": function () {
            failureStatus();
            log("warn", "Turnstile expired callback");
            redirectToThankYou("turnstileExpired");
          },
          "timeout-callback": function () {
            failureStatus();
            log("warn", "Turnstile timeout callback");
            redirectToThankYou("turnstileTimeout");
          }
        });
      })
      .catch(function (error) {
        failureStatus();
        log(
          "error",
          "Turnstile could not be loaded.",
          "message=" + (error && error.message ? error.message : "unknown")
        );
        redirectToThankYou("turnstileLoadFailure");
      });
  }

  function initialise() {
    initialiseFormPersistence();
    initialiseSuccessSubscription();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialise, { once: true });
  } else {
    initialise();
  }
})();
